import type { OrganizationTreeProps } from "./organization-tree.type";

import { useGetOrganizationTree } from "@/entities/asset-tree";
import ModelTree from "@/modules/model-tree";

export const OrganizationTree = ({
  organizationId,
  ...options
}: OrganizationTreeProps) => {
  const { tree, isLoading } = useGetOrganizationTree(organizationId);

  const locations = tree[0]?.children ?? [];

  return <ModelTree nodes={locations} loading={isLoading} {...options} />;
};
